import { simpleSet } from '@r/reducers/utils';

const setCalculationModeHingesValue = simpleSet as
  redux.reducers.calculationMode.settings.materials.hinges.value;

export const value = setCalculationModeHingesValue(
  'SET_CALCULATION_MODE_HINGES_VALUE',
  { value: '', label: '' }
);
